import { useRef, useCallback } from 'react';
import { MotionValue } from 'framer-motion';
import { reducer } from "./reducers";
/**
 * Handle panels state
 *
 * This is a reducer pattern similar to redux, but state
 * changes don't cause rerenders for performance reasons. Instead,
 * updates are done imperatively via transitive updates using
 * framer-motion's motion values.
 */

export function usePanels(options) {
  var stateRef = useRef(createDefaultState());
  var dispatch = useCallback(function (action) {
    stateRef.current = reducer(stateRef.current, action);
  }, []);

  if (!stateRef.current.initialized) {
    dispatch({
      type: 'UPDATE',
      payload: options
    });
    dispatch({
      type: 'COMMIT_ALL'
    });
  }

  return {
    stateRef: stateRef,
    dispatch: dispatch
  };
}

function createDefaultState() {
  return {
    initialized: false,
    activeBreakpoint: 'sm',
    sm: createDefaultGridState('sm'),
    md: createDefaultGridState('md'),
    lg: createDefaultGridState('lg')
  };
}

function createDefaultGridState(breakpoint) {
  return {
    breakpoint: breakpoint,
    activeDimension: null,
    activeIndex: null,
    rows: {
      breakpoint: breakpoint,
      type: 'rows',
      offset: new MotionValue(0),
      template: new MotionValue(''),
      units: []
    },
    columns: {
      breakpoint: breakpoint,
      type: 'columns',
      offset: new MotionValue(0),
      template: new MotionValue(''),
      units: []
    },
    areas: [],
    areaTemplate: new MotionValue('')
  };
}